import React from 'react';
import 'antd/dist/antd.css';
import { Result, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import {colors} from "../../Constants/Constants";
import not from '../../Assets/404.svg';

const NotFound = () => {
    const history = useHistory();

    return (
        <div>
            <Result
               icon={<img src={not}/>}
                subTitle="Sorry, the page you visited does not exist."
                extra={
                    <Button type="primary" style={{backgroundColor:colors.darkOrange, borderColor: colors.darkOrange}} onClick={() => history.goBack()}>
                        Back Home
                    </Button>
                }
            />
        </div>
    );
};

export default NotFound;